import { render, staticRenderFns } from "./homeDevTask.vue?vue&type=template&id=3b9ad9de&"
import script from "./homeDevTask.vue?vue&type=script&lang=js&"
export * from "./homeDevTask.vue?vue&type=script&lang=js&"
import style0 from "./homeDevTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports